import { FUTURES } from "../../constants";
import { CLOSE_REASON, getCloseReason } from "@helpers/futures/closeReason";

// Kinds of the futures toasts, see FuturesNotification
export const NOTIFICATION_TYPE = {
  POSITION_OPENED: "positionOpened",
  POSITION_CLOSED: "positionClosed",
  TAKE_PROFIT_HIT: "positionTakeProfit",
  STOP_LOSS_HIT: "positionStopLoss",
  POSITION_LIQUIDATED: "positionLiquidated",
  POSITION_PARTIALLY_CLOSED: "positionPartiallyClosed",
  RISK_VALIDATION_ERROR: "riskValidationError",
};

const AUTO_CLOSE_TYPE = {
  [CLOSE_REASON.TAKE_PROFIT]: NOTIFICATION_TYPE.TAKE_PROFIT_HIT,
  [CLOSE_REASON.STOP_LOSS]: NOTIFICATION_TYPE.STOP_LOSS_HIT,
  [CLOSE_REASON.LIQUIDATION]: NOTIFICATION_TYPE.POSITION_LIQUIDATED,
};

/**
 * Toast for a position closed without the user: take profit, stop loss,
 * liquidation, or the plain "Bet Closed" when the reason isn't known.
 * @param {object} position closed position, ideally its record from the history
 */
export const showAutoCloseNotification = (position) => ({
  type: FUTURES.SHOW_NOTIFICATION,
  payload: {
    ...position,
    notificationType:
      AUTO_CLOSE_TYPE[getCloseReason(position)] ??
      NOTIFICATION_TYPE.POSITION_CLOSED,
  },
});

/**
 * Error toast for invalid TP/SL values when trying to place a trade.
 * @param {{ title: string, text: string }} params
 */
export const showRiskValidationError = ({ title, text }) => ({
  type: FUTURES.SHOW_NOTIFICATION,
  payload: {
    id: `risk-error-${Date.now()}`,
    notificationType: NOTIFICATION_TYPE.RISK_VALIDATION_ERROR,
    title,
    text,
  },
});

/**
 * Toast for a partial close, to dispatch once the partial close request succeeds.
 * @param {{ position: object, percent: number }} params
 *   position is the open position, percent the closed share
 */
export const showPartialCloseNotification = ({ position, percent }) => ({
  type: FUTURES.SHOW_NOTIFICATION,
  payload: {
    ...position,
    // Several partial closes of one position stay separate toasts
    id: `${position.id}-partial-${Date.now()}`,
    notificationType: NOTIFICATION_TYPE.POSITION_PARTIALLY_CLOSED,
    percent,
  },
});
